import { render, staticRenderFns } from "./ClientProfileMenu.vue?vue&type=template&id=c4d786c6&scoped=true&"
import script from "./ClientProfileMenu.vue?vue&type=script&lang=js&"
export * from "./ClientProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileMenu.vue?vue&type=style&index=0&id=c4d786c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d786c6",
  null
  
)

export default component.exports